import { AGENT } from 'conversations-message-history/constants/messageUses';
import { getFullUrl } from 'hubspot-url-utils';
import SlottedMessage from '../../slotted-message/SlottedMessage';
import DeliveryStatusFooter from '../../delivery-status/DeliveryStatusFooter';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Could not find a declaration file for module '../p... Remove this comment to see the full error message
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import PortalIdParser from 'PortalIdParser';
import { Text } from 'foundations-components/components/Text';
import { WarningIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Link } from 'foundations-components/transitional/components/Link';
import AutomatedMessageAvatar from '../../avatar/AutomatedMessageAvatar';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BatchSmsGeneratedUserMessage = ({
  message,
  campaignName = '',
  positionDescriptors,
  visitorLastReadTimestamp,
  ungatedForThreadMessagesUIImprovements
}) => {
  const {
    text,
    status,
    contentId
  } = message;
  const campaignUrl = `${getFullUrl('app')}/sms/${PortalIdParser.get()}/details/${contentId}/`;
  const timestamp = getTimestamp(message);
  return /*#__PURE__*/_jsx(SlottedMessage, {
    container: {
      componentProps: {
        'data-test-id': 'primary-message-BATCH_SMS',
        use: AGENT,
        ungatedForThreadMessagesUIImprovements
      }
    },
    avatar: {
      Component: AutomatedMessageAvatar
    },
    title: {
      Component: FormattedMessage,
      componentProps: {
        message: 'conversations-inbox-message-history.responder.automatic'
      }
    },
    timestamp: {
      componentProps: {
        timestamp
      }
    },
    body: {
      componentProps: {
        contentText: text,
        isPlainText: true
      }
    },
    footerTitle: {
      Component: FormattedMessage,
      componentProps: {
        message: 'conversations-inbox-message-history.batch-sms-generated-user-message.source-campaign'
      }
    },
    footerBody: {
      Component: Link,
      componentProps: {
        use: 'blue',
        href: campaignUrl,
        truncate: true,
        external: true,
        children: /*#__PURE__*/_jsx(_Fragment, {
          children: campaignName || campaignUrl
        })
      }
    },
    annotation: status.messageStatus === 'FAILED' ? {
      Component: Text,
      componentProps: {
        color: 'text-alert-default',
        typography: 'detail-200',
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "start",
          children: [/*#__PURE__*/_jsx(Flex, {
            flexDirection: "column",
            alignItems: "center",
            marginInlineEnd: "100",
            children: /*#__PURE__*/_jsx(WarningIcon, {})
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.DEFAULT"
          })]
        })
      }
    } : {
      Component: DeliveryStatusFooter,
      componentProps: {
        timestamp,
        status,
        positionDescriptors,
        visitorLastReadTimestamp
      }
    }
  });
};
BatchSmsGeneratedUserMessage.displayName = 'BatchSmsGeneratedUserMessage';
export default BatchSmsGeneratedUserMessage;